/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */

export const GET_OTHER_USER_PROFILE_CALL = 'GET_OTHER_USER_PROFILE_CALL';
export const GET_OTHER_USER_PROFILE_DONE = 'GET_OTHER_USER_PROFILE_DONE';
export const GET_OTHER_USER_PROFILE_FAIL = 'GET_OTHER_USER_PROFILE_FAIL';
